<app-navigation tagline="ERGEBNIS" marginLeftClass="ml-10"></app-navigation>
<ion-content class="ion-padding">
  <div class="content2">
 Hier sind nochmal Deine Antworten zum Nachschauen:
</div>
    <ion-accordion-group multiple="true" class="ion-no-margin" expand="inset">
      <ion-accordion *ngFor="let question of questions; let i = index">
        <ion-item slot="header" color="primary" class="question" color="dark">
          <ion-label class="ion-text-wrap">{{stripHtml(question.title, false)}}</ion-label>
        </ion-item>
        <div class="ion-padding content" slot="content">
          Deine Antwort: <ion-icon
          style=" font-size: 20px;"
          [src]="question.answer === true?'assets/img/hand-thumbs-up-fill.svg':
          'assets/img/hand-thumbs-down-fill.svg'"
          ></ion-icon><br>
          <div [innerHTML]="(question.answer ? question.feedbackTextYes: question.feedbackTextNo)"></div>
        </div>
      </ion-accordion>
    </ion-accordion-group>
    <div style="margin-top: 1em">
    <ion-button (click)="downloadPdf()" color="dark" style="border: 1px solid #fff; color: #fff;">
      <ion-icon name="download-outline" style="padding-right:10px" ></ion-icon>
      PDF herunterladen
    </ion-button>
    <ion-button (click)="startAgain()" color="dark" style=" border-radius:0; border: 1px solid #fff; color: #fff">
      <ion-icon name="rocket-outline" style="padding-right:10px" ></ion-icon>
      Check neu starten
    </ion-button>

      <ion-toolbar color="transparent" >
        <ion-icon (click)="nextButtonHandler()" style="font-size: 50px" color="light" slot="end" src="assets/img/arrowNext.svg"></ion-icon>
    </ion-toolbar>


  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-title class="footer">#ORIENTANDO</ion-title>
  </ion-toolbar>
</ion-footer>
